/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Badge } from 'antd';
import Tooltip from 'components/Tooltip';
import messages from './messages';

import './breadcrumb.style.css';

const Breadcrumb = ({
    currentPeriodLabel,
    previousPeriodLabel,
    nextPeriodLabel,
    previousPeriodClicked,
    nextPeriodClicked,
    showCalendarLink = false,
    calendarDate = '',
    calendarHasRecommendation = false,
}) => {
    const navigate = useNavigate();
    const navigateToDayView = () => {
        navigate('/app/sellingRateCalendar', { state: { preselectedDate: calendarDate } });
    };
    return (
        <div className="Breadcrumb">
            {previousPeriodLabel && (
                <div className="BreadcrumbNavItem" onClick={previousPeriodClicked}>
                    <i className="fa fa-angle-left" />
                    {previousPeriodLabel}
                </div>
            )}
            {!previousPeriodLabel && <div className="BreadcrumbNavItem" />}
            <div className="BreadcrumbTitle">
                {currentPeriodLabel}
                {showCalendarLink ? (
                    <Tooltip title={<FormattedMessage {...messages.rateCalendarLinkButton} />} placement="bottom">
                        <span className="BreadcrumbCalendarLink" onClick={navigateToDayView}>
                            {calendarHasRecommendation ? (
                                <Badge dot="true" style={{ zIndex: 99 }}>
                                    <i className="fa fa-calendar" />
                                </Badge>
                            ) : (
                                <i className="fa fa-calendar" />
                            )}
                        </span>
                    </Tooltip>
                ) : (
                    <></>
                )}
            </div>
            {nextPeriodLabel && (
                <div className="BreadcrumbNavItem" onClick={nextPeriodClicked}>
                    {nextPeriodLabel}
                    <i className="fa fa-angle-right" />
                </div>
            )}
            {!nextPeriodLabel && <div className="BreadcrumbNavItem" />}
        </div>
    );
};

export default Breadcrumb;
